var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-bar__social-media"},[_c('h3',{staticClass:"subscription-bar__social-media__title"},[_vm._v("\n    "+_vm._s(_vm.$i18n('blog.our-socials'))+"\n  ")]),_vm._v(" "),_c('Socials',{attrs:{"icon-class":"text-[#0e1017] hover:text-blue-600 duration-200"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }